import _regeneratorRuntime from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.some.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { Action, State, Mutation } from 'vuex-class';
import Price from '@/components/price/index.vue';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import BackTop from '@/common/backtop.vue';
import Regular from '@/components/regular/index.vue';
import * as _ from 'lodash';
import { getBannerList as _getBannerList, pageVisit as _pageVisit, getDataBanner, getIndexNav as _getIndexNav, popularizeList, popularizeReceive as _popularizeReceive, popularizeClose, receiveFirstBuyCoupon, queryPrintSize, normalRecommend as _normalRecommend, dataNormalRecommend, printLabelSize, indexPostion, flashSalePageVisit, recommendProductInfo, deviceList } from '@/services/http';
import { readCookie } from '@/tools/tools';
import hotList from '@/components/home/hotList.vue';
import classify from '@/components/home/classify.vue';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    _this = _callSuper(this, default_1, arguments);
    _this.searchText = '';
    _this.selectedDeviceId = 5; // 默认选中的设备ID
    _this.showStauts = false;
    _this.devices = [];
    _this.isFixed = false;
    _this.bannerList = [];
    _this.navList = [];
    _this.isFLash = false;
    _this.status = true;
    _this.isShowPaper = false;
    // 开屏推广大图
    _this.appSourceUrl = '';
    // 开屏推广小图
    _this.smallSourceUrl = '';
    _this.flashSaleId = '';
    _this.searchWidth = ''; // 搜索宽度
    _this.searchHeight = ''; // 搜索高度
    _this.printSizeList = [];
    _this.objData = {};
    _this.normalRecommendList = [];
    // 首页推荐耗材
    _this.recommendProductInfo = {};
    _this.recommendNum = 1; // 热门推荐购买数量
    _this.showProductInfor = false; // 是否显示退耗材
    return _this;
  }
  // 根据搜索文本过滤设备列表
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "filteredDevices",
    get: function get() {
      var _this2 = this;
      if (!this.searchText) {
        return this.devices;
      }
      return this.devices.filter(function (device) {
        return device.name.toLowerCase().includes(_this2.searchText.toLowerCase());
      });
    }
  }, {
    key: "handInput",
    value: function handInput() {
      this.handData();
    }
  }, {
    key: "handTypeId",
    value: function handTypeId(obj) {
      this.objData = obj;
    }
  }, {
    key: "handleIconClick",
    value: function handleIconClick() {
      this.searchText = '';
      this.handData();
    }
  }, {
    key: "handleGlobalClick",
    value: function handleGlobalClick(event) {
      this.$refs.classifyRef.sizeStauts = false;
      // 1. 提前返回的条件合并：如果弹窗关闭，或者事件目标不存在，则不做任何事
      if (!this.showStauts || !event.target) {
        return;
      }
      // 2. 获取豁免区的 DOM 元素
      var deviceSelectorElement = this.$refs.deviceSelectorRef;
      // 创建一个包含所有豁免区域的列表
      var exemptedElements = [deviceSelectorElement];
      // 检查点击事件的目标是否在任何一个豁免区域内部
      var isClickInside = exemptedElements.some(function (el) {
        return (// 使用 ?. 来安全地调用 contains
          el === null || el === void 0 ? void 0 : el.contains(event.target)
        );
      });
      // 4. 如果点击【不在】豁免区内部，则关闭弹窗
      if (!isClickInside) {
        this.showStauts = false;
      }
    }
  }, {
    key: "handData",
    value: function handData() {
      var _this3 = this;
      deviceList({
        // productTypeId: obj.productTypeId?obj.productTypeId:obj.parentTypeId,//二级分类编号
        // productParentTypeId: obj.parentTypeId,//一级分类编号
        printerModel: this.searchText,
        printerSize: ''
      }).then(function (res) {
        _this3.devices = res.data.data;
        //根据选中的设备做首次加载
        var data = _this3.devices.filter(function (item) {
          return item.useStatus == 1;
        });
        if (data && _this3.status) {
          var _data$;
          _this3.status = false;
          // this.selectDevice(data[0])
          _this3.selectedDeviceId = (_data$ = data[0]) === null || _data$ === void 0 ? void 0 : _data$.deviceId;
          _this3.setPrinterModel(null);
          _this3.setPrinterModel(data[0]);
        }
      });
    }
  }, {
    key: "created",
    value: function () {
      var _created = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.setCardNum();
            case 2:
              _context.next = 4;
              return this.getPopularizeList();
            case 4:
              _context.next = 6;
              return this.getPrintSize();
            case 6:
              _context.next = 8;
              return this.normalRecommend();
            case 8:
              _context.next = 10;
              return this.handData();
            case 10:
              _context.next = 12;
              return this.getBannerList();
            case 12:
              _context.next = 14;
              return this.pageVisit();
            case 14:
              _context.next = 16;
              return this.setWhiteStauts();
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function created() {
        return _created.apply(this, arguments);
      }
      return created;
    }()
  }, {
    key: "handTips",
    value: function handTips() {
      this.$refs.RegularRef.dialogVisible = true;
    }
    /**
     * 点击商品图片，进入商品详情页
     */
  }, {
    key: "goProductDetails",
    value: function goProductDetails() {
      this.$router.push("/details?id=".concat(this.recommendProductInfo.id, "&productPriceId=").concat(this.recommendProductInfo.productPriceId));
    }
    /**
     * 获取推荐耗材接口信息v2.1去除推荐耗材逻辑
     */
  }, {
    key: "getrecommendProductInfo",
    value: (function () {
      var _getrecommendProductInfo = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return recommendProductInfo({
                companyId: 1
              });
            case 2:
              res = _context2.sent;
              if (res.data.code === 100) {
                this.recommendProductInfo = res.data.data;
                this.showProductInfor = true;
              } else {
                this.showProductInfor = false;
              }
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getrecommendProductInfo() {
        return _getrecommendProductInfo.apply(this, arguments);
      }
      return getrecommendProductInfo;
    }() // 选择设备
    )
  }, {
    key: "selectDevice",
    value: function selectDevice(item) {
      this.selectedDeviceId = item === null || item === void 0 ? void 0 : item.deviceId;
      this.setPrinterModel(item);
      this.showStauts = false;
    }
    // 清除选择
  }, {
    key: "clearSelection",
    value: function clearSelection() {
      this.selectedDeviceId = null;
      this.setPrinterModel(null);
      this.showStauts = false;
    }
    /**
     * 推荐耗材去结算
     */
  }, {
    key: "goSettle",
    value: function goSettle() {
      var confirmlist = [{
        productId: this.recommendProductInfo.id,
        freight: null,
        id: this.recommendProductInfo.productPriceId,
        mallImage: {
          source_url: this.recommendProductInfo.listImagePath.sourceUrl,
          product_name: ''
        },
        natureList: [{
          id: '',
          index: 0,
          natureName: this.recommendProductInfo.productSize,
          natureValue: this.recommendProductInfo.productMaterial
        }],
        num: this.recommendNum,
        price: this.recommendProductInfo.lowestPrice.split(',')[0],
        totalPrice: _.round(_.multiply(Number(this.recommendProductInfo.lowestPrice.split(',')[0]), this.recommendNum), 2)
      }];
      this.CONFIRMORDER(confirmlist);
      this.$router.push('/orderconfirm?type=2');
    }
    // 获取常用推荐
  }, {
    key: "normalRecommend",
    value: function () {
      var _normalRecommend2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _normalRecommend({
                companyId: 1
              });
            case 2:
              res = _context3.sent;
              this.normalRecommendList = res.data.data;
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function normalRecommend() {
        return _normalRecommend2.apply(this, arguments);
      }
      return normalRecommend;
    }()
  }, {
    key: "goodsgo",
    value: function goodsgo(id) {
      var anchor = readCookie('anchor');
      dataNormalRecommend({
        equip: anchor ? anchor.equip : 4,
        version: anchor ? anchor.version : '',
        src: anchor ? anchor.src ? anchor.src : 2 : 4,
        model: anchor ? anchor.model : '',
        equipVersion: anchor ? anchor.equipVersion : '',
        equipMeid: anchor ? anchor.equipMeid : '',
        eventNo: '3.7.1.0.0.0.1',
        companyId: 1
      });
      this.$router.push("/details?id=".concat(id, "&from=hotlist"));
    }
    // 获取打印尺寸
  }, {
    key: "getPrintSize",
    value: function () {
      var _getPrintSize = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return queryPrintSize({
                channel: 1
              });
            case 2:
              res = _context4.sent;
              this.printSizeList = res.data.data;
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getPrintSize() {
        return _getPrintSize.apply(this, arguments);
      }
      return getPrintSize;
    }() // 到搜索页面
  }, {
    key: "goSearch",
    value: function goSearch(item) {
      var anchor = readCookie('anchor');
      printLabelSize({
        equip: anchor ? anchor.equip : 4,
        version: anchor ? anchor.version : '',
        src: anchor ? anchor.src ? anchor.src : 2 : 4,
        model: anchor ? anchor.model : '',
        equipVersion: anchor ? anchor.equipVersion : '',
        equipMeid: anchor ? anchor.equipMeid : '',
        eventNo: '3.8.2.0.0.0.1',
        companyId: 1,
        printSize: item,
        isInput: 1
      });
      this.$router.push("/classify?keyword=".concat(item));
    }
  }, {
    key: "goClassify",
    value: function goClassify() {
      // var data = {
      //   msgtype: 'cardMessage',
      //   cards: 
      //     {
      //       type: 'product',// 商品
      //       data: [{
      //         id: '123', // 商品id
      //         picture: 'https://imagepc.ctaiot.com/mall/product_main_pic/f2033dc1-42a7-4145-b4bf-c82ee9b4a840.jpg', // 商品图片
      //         desc: '你好你好你好你好你好你好你好你好你好你好', // 描述
      //         title: '你好你好gggggggggggggggggggggggggg', // 标题
      //         price: '999999999',// 价格
      //         url: '' // actions 0的情况 跳转链接
      //       }]
      //     }
      //   ,// 这里是消息的配置，至少一条，具体配置看卡片类型定义
      // }
      //     var data = {
      //       // 要发送到的卡片消息数据对象  
      //         "msgtype": "miniprogrampage",
      //         "title":"title",  
      //         "name": "name",
      //         "headimg": "headimg",
      //         "pagepath":"pagepath",
      //         "thumb_media_id":"2GffOSv_K-3MgguUtgO6OG7c6ZvNrzW1agt4gzW37j7kFLZiuFyvRKLc_8irQzua",
      //         "thumburl": "https://imagepc.ctaiot.com/mall/product_main_pic/f2033dc1-42a7-4145-b4bf-c82ee9b4a840.jpg"
      // }
      //     // 将数据用postMessage的方式发送到七鱼
      //     window.parent.postMessage(data, '*');
      if (!this.searchWidth || !this.searchHeight) {
        return;
      }
      // let str: string = ''
      // if (this.searchWidth) {
      //   str = this.searchWidth
      // }
      // if (!this.searchWidth && this.searchHeight) {
      //   str = this.searchHeight
      // }
      // if (this.searchWidth && this.searchHeight) {
      //   str += `*${this.searchHeight}`
      // }
      var anchor = readCookie('anchor');
      printLabelSize({
        equip: anchor ? anchor.equip : 4,
        version: anchor ? anchor.version : '',
        src: anchor ? anchor.src ? anchor.src : 2 : 4,
        model: anchor ? anchor.model : '',
        equipVersion: anchor ? anchor.equipVersion : '',
        equipMeid: anchor ? anchor.equipMeid : '',
        eventNo: '3.8.1.0.0.0.1',
        companyId: 1,
        printSize: "".concat(this.searchWidth, "*").concat(this.searchHeight),
        isInput: 0
      });
      this.$router.push("/classify?keyword=".concat(this.searchWidth, "*").concat(this.searchHeight));
    }
  }, {
    key: "getBannerList",
    value: function () {
      var _getBannerList2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var anchor, res;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              anchor = readCookie('anchor');
              _context5.next = 3;
              return _getBannerList({
                companyId: 1,
                company: '',
                equip: anchor ? anchor.equip : 4,
                version: anchor ? anchor.version : '',
                platform: 2
              });
            case 3:
              res = _context5.sent;
              this.bannerList = res.data.data;
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function getBannerList() {
        return _getBannerList2.apply(this, arguments);
      }
      return getBannerList;
    }()
  }, {
    key: "getIndexNav",
    value: function () {
      var _getIndexNav2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var res;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _getIndexNav({
                type: 2,
                companyId: 1
              });
            case 2:
              res = _context6.sent;
              if (res.data.code === 100) {
                this.navList = res.data.data.slice(0, 4);
              }
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function getIndexNav() {
        return _getIndexNav2.apply(this, arguments);
      }
      return getIndexNav;
    }()
  }, {
    key: "goDetails",
    value: function () {
      var _goDetails = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(jumpUrl) {
        var anchor, res;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              anchor = readCookie('anchor');
              _context7.next = 3;
              return getDataBanner({
                equip: anchor ? anchor.equip : 4,
                version: anchor ? anchor.version : '',
                src: anchor ? anchor.src ? anchor.src : 2 : 4,
                model: anchor ? anchor.model : '',
                equipVersion: anchor ? anchor.equipVersion : '',
                equipMeid: anchor ? anchor.equipMeid : '',
                eventNo: '2.4.0.0.0.0.0',
                companyId: 1
              });
            case 3:
              res = _context7.sent;
              if (res.data.code === 100) {
                if (jumpUrl) {
                  window.location.href = jumpUrl;
                }
              }
            case 5:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      function goDetails(_x) {
        return _goDetails.apply(this, arguments);
      }
      return goDetails;
    }() // 访问页面数据埋点
  }, {
    key: "pageVisit",
    value: function pageVisit() {
      var anchor = readCookie('anchor');
      _pageVisit({
        pageType: 0,
        equip: anchor ? anchor.equip : 4,
        version: anchor ? anchor.version : '',
        src: anchor ? anchor.src ? anchor.src : 2 : 4,
        model: anchor ? anchor.model : '',
        equipVersion: anchor ? anchor.equipVersion : '',
        equipMeid: anchor ? anchor.equipMeid : '',
        companyId: 1
      });
    }
    // 浏览更多
  }, {
    key: "watchMore",
    value: function watchMore(id) {
      this.$router.push("/classify?parentTypeId=".concat(id));
    }
  }, {
    key: "openWin",
    value: function () {
      var _openWin = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(item) {
        var anchor, response;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              anchor = readCookie('anchor');
              if (!(item.navType === 1)) {
                _context8.next = 5;
                break;
              }
              this.$router.push("/classify?productTypeId=".concat(item.navTypeValue));
              _context8.next = 21;
              break;
            case 5:
              if (!(item.navType === 2)) {
                _context8.next = 9;
                break;
              }
              this.$router.push("/details?id=".concat(item.navTypeValue));
              _context8.next = 21;
              break;
            case 9:
              if (!(item.navType === 3)) {
                _context8.next = 13;
                break;
              }
              this.$router.push("/special?id=".concat(item.id));
              _context8.next = 21;
              break;
            case 13:
              if (!(item.navName === '限时抢购')) {
                _context8.next = 20;
                break;
              }
              _context8.next = 16;
              return flashSalePageVisit({
                equip: anchor ? anchor.equip : 4,
                version: anchor ? anchor.version : '',
                model: anchor ? anchor.model : '',
                equipVersion: anchor ? anchor.equipVersion : '',
                equipMeid: anchor ? anchor.equipMeid : '',
                companyId: 1
              });
            case 16:
              response = _context8.sent;
              if (response.data.code === 100) {
                window.location.href = item.jumpUrl;
              }
              _context8.next = 21;
              break;
            case 20:
              window.location.href = item.jumpUrl;
            case 21:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function openWin(_x2) {
        return _openWin.apply(this, arguments);
      }
      return openWin;
    }() // 查询开屏推广图片
  }, {
    key: "getPopularizeList",
    value: function () {
      var _getPopularizeList = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var res;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return popularizeList({
                showPostion: 1,
                companyId: 1
              });
            case 2:
              res = _context9.sent;
              this.isFLash = res.data.data.length !== 0 && res.data.data[0].pcSourceUrl !== '';
              if (res.data.data.length !== 0) {
                this.appSourceUrl = res.data.data[0].pcSourceUrl;
                this.flashSaleId = res.data.data[0].id;
                if (this.appSourceUrl === '') {
                  this.smallSourceUrl = res.data.data[0].smallSourceUrl;
                } else {
                  this.smallSourceUrl = '';
                }
              } else {
                this.appSourceUrl = '';
                this.flashSaleId = '';
                this.smallSourceUrl = '';
              }
            case 5:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function getPopularizeList() {
        return _getPopularizeList.apply(this, arguments);
      }
      return getPopularizeList;
    }() // 领取开屏推广
  }, {
    key: "popularizeReceive",
    value: function () {
      var _popularizeReceive2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10(str) {
        var res;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return _popularizeReceive({
                id: this.flashSaleId,
                companyId: 1
              });
            case 2:
              res = _context10.sent;
              if (res.data.code === 100) {
                this.getPopularizeList();
                if (str === 'isFlash') {
                  this.isFLash = false;
                }
                this.$message.success('领取成功！');
              } else {
                this.$message.error(res.data.message);
              }
            case 4:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function popularizeReceive(_x3) {
        return _popularizeReceive2.apply(this, arguments);
      }
      return popularizeReceive;
    }() // 关闭开屏推广
  }, {
    key: "closeSale",
    value: function () {
      var _closeSale = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              this.isFLash = false;
              _context11.next = 3;
              return popularizeClose({
                id: this.flashSaleId
              });
            case 3:
              _context11.next = 5;
              return this.getPopularizeList();
            case 5:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function closeSale() {
        return _closeSale.apply(this, arguments);
      }
      return closeSale;
    }() // 首购特惠广告图跳转链接
  }, {
    key: "goLink",
    value: function () {
      var _goLink = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var anchor, res;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              anchor = readCookie('anchor');
              indexPostion({
                bannerType: this.notifysState.serviceList.bannerType,
                equip: anchor ? anchor.equip : 4,
                version: anchor ? anchor.version : '',
                src: anchor ? anchor.src ? anchor.src : 2 : 4,
                model: anchor ? anchor.model : '',
                equipVersion: anchor ? anchor.equipVersion : '',
                equipMeid: anchor ? anchor.equipMeid : '',
                companyId: 1
              });
              if (!(this.notifysState.serviceList.bannerType === 1)) {
                _context12.next = 9;
                break;
              }
              _context12.next = 5;
              return receiveFirstBuyCoupon({
                companyId: 1
              });
            case 5:
              res = _context12.sent;
              if (res.data.data === '') {
                this.$router.push('/coupon');
              } else {
                this.$message.success('领取成功！');
                this.$router.push('/coupon');
              }
              _context12.next = 10;
              break;
            case 9:
              if (this.notifysState.serviceList.pcUrl !== '') {
                window.location.href = this.notifysState.serviceList.pcUrl;
              }
            case 10:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function goLink() {
        return _goLink.apply(this, arguments);
      }
      return goLink;
    }()
  }]);
}(Vue);
__decorate([Action('card/setCardNum')], default_1.prototype, "setCardNum", void 0);
__decorate([Action('user/setUserInfoList')], default_1.prototype, "setUserInfoList", void 0);
__decorate([Action('equipment/setPrinterModel')], default_1.prototype, "setPrinterModel", void 0);
__decorate([Mutation('home/ADDSMALLIMG')], default_1.prototype, "ADDSMALLIMG", void 0);
__decorate([Action('white/setWhiteStauts')], default_1.prototype, "setWhiteStauts", void 0);
__decorate([State('notifys')], default_1.prototype, "notifysState", void 0);
__decorate([Mutation('order/CONFIRMORDER')], default_1.prototype, "CONFIRMORDER", void 0);
default_1 = __decorate([Component({
  name: 'Home',
  components: {
    Header: Header,
    Price: Price,
    Footer: Footer,
    BackTop: BackTop,
    hotList: hotList,
    classify: classify,
    Regular: Regular
  }
})], default_1);
export default default_1;